function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 26h12V14H0zM12 0C5.37 0 0 5.37 0 12h12V0zM0 40c6.629 0 12-5.371 12-12H0v12zM14 0c6.629 0 12 5.371 12 12H14V0zm0 26c6.629 0 12-5.371 12-12H14v12z",
  fill: "#262C37",
  fillRule: "evenodd"
});

function SvgRr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 40
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDI2IDQwIj4KICAgIDxnIGZpbGw9IiMyNjJDMzciIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMjZoMTJWMTRIMHpNMTIgMEM1LjM3IDAgMCA1LjM3IDAgMTJoMTJWMHpNMCA0MGM2LjYyOSAwIDEyLTUuMzcxIDEyLTEySDB2MTJ6TTE0IDBjNi42MjkgMCAxMiA1LjM3MSAxMiAxMkgxNFYwek0xNCAyNmM2LjYyOSAwIDEyLTUuMzcxIDEyLTEySDE0djEyeiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgRr as ReactComponent };